import { render, staticRenderFns } from "./FormRSPManagement.vue?vue&type=template&id=0b468ed4&scoped=true&"
import script from "./FormRSPManagement.vue?vue&type=script&lang=js&"
export * from "./FormRSPManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b468ed4",
  null
  
)

export default component.exports